import { createContext, useContext } from '@wordpress/element';
export const CompositeContext = createContext({});
CompositeContext.displayName = 'CompositeContext';
export const useCompositeContext = () => useContext(CompositeContext);